import { CardsSectionProps } from '../config';
import { DETAIL_CARD_INFO_MAP, DetailCard } from '../consts';
import { getResendBlockedReason } from '../utils';
import Accordion from './Accordion';
import InfoGrid from './InfoGrid';
import ResendActivationLinkButton from './ResendActivationLinkButton';

function DigitalCards({ order, canResend }: CardsSectionProps) {
  const detailCards: DetailCard[] = order.cards.flatMap((card) =>
    (card.activation_links ?? []).map((link) => ({ card, link }))
  );

  if (detailCards.length === 0) {
    return <div className="text-base">No cards issued yet</div>;
  }

  return (
    <div className="flex flex-col divide-y divide-palette-color-bg-grey">
      {detailCards.map((detailCard, index) => (
        <Accordion key={detailCard.link.uuid} label={`Card ${index + 1}`}>
          <div className="pb-4">
            <InfoGrid rows={DETAIL_CARD_INFO_MAP} entity={detailCard} breakAll>
              {canResend && (
                <div className="flex justify-end">
                  <ResendActivationLinkButton
                    linkUuid={detailCard.link.uuid}
                    orderUuid={order.uuid}
                    blockedReason={getResendBlockedReason({
                      order,
                      card: detailCard.card,
                      link: detailCard.link,
                    })}
                  />
                </div>
              )}
            </InfoGrid>
          </div>
        </Accordion>
      ))}
    </div>
  );
}

export default DigitalCards;
